import { render } from "./dialog-requested-events.vue?vue&type=template&id=f0418d70&scoped=true"
import script from "./dialog-requested-events.vue?vue&type=script&lang=js"
export * from "./dialog-requested-events.vue?vue&type=script&lang=js"

import "./dialog-requested-events.vue?vue&type=style&index=0&id=f0418d70&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0418d70"]])

export default __exports__